import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";

import { api } from "../../../utils/Api";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useParams } from "react-router-dom";

import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

const animatedComponents = makeAnimated();

let myModal: any;

const initial_value = {
  work_from: "",
  work_to: "",
  file_path: "",
  reason: "",
  quantity: "",
};

export default function ModalFinish(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [save_data, SetSaveData] = useState(initial_value);

  useEffect(() => {
    console.log("ModalFinish On mount :", props);
    let myModal1: any = document.getElementById("FinishModal");
    myModal1.addEventListener("hidden.bs.modal", function (event: any) {
      console.log("event :", event);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.data.open) {
      console.log("ModalFinish On Open :", props);
      myModal = new bootstrap.Modal(document.getElementById("FinishModal"), {});
      myModal.show();
    }
  }, [props.data.open]);

  async function finish() {
    console.log("update_shared shared_data :", shared_data);
    console.log("update_shared save_data :", save_data);
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        id: props.data.task_data.id,
      },
      post: {
        data: save_data,
        duration: work_hour,
      },
    };
    console.log("pass_data :", pass_data);
    let response = await api("/editortask/update_shared", pass_data);
    console.log("update_shared Response :", response);
    if (response.response.hasOwnProperty("status")) {
      if (response.response.status == "success") {
        let share_value = response.response.data;
        SetSaveData(share_value);
        SetOrgSaveData(share_value);
        SetEditValue(false);

        Object.keys(share_value).map((key: any, index: any) => {
          share_value[key].map((ele: any, ele_index: any) => {
            if (ele.checked) {
              SetSharedData((s_prevValue: any) => {
                if (s_prevValue.hasOwnProperty(key)) {
                  s_prevValue[key].push(ele.id);
                } else {
                  let save_value = [];
                  save_value.push(ele.id);
                  s_prevValue[key] = save_value;
                }
                return { ...s_prevValue };
              });
            }
          });
        });
      }
    }
  }

  async function finish_task() {
    let work_value = {
      work_from: moment(save_data.work_from).format("DD-MM-yyyy h:mm a"),
      work_to: moment(save_data.work_to).format("DD-MM-yyyy h:mm a"),
      file_path: save_data.file_path,
      reason: save_data.reason,
      quantity: save_data.quantity,
    };
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        task_assigned_id: props.data.data.id,
        work_details: [work_value],
      },
    };
    console.log("finish_task pass_data:", pass_data);

    let response = await api("/editortask/finish_assigned_task", pass_data);
    console.log("/editortask/finish_assigned_task response:", response);
    if (response.status_code == 200) {
      let item = close_data;
      item.action = "save";
      //   item.value = data.response.events[0];
      SetCloseData(item);
      SetSaveData(initial_value);
      myModal.hide();
    }
  }

  return (
    <div
      className="modal fade"
      id="FinishModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          {/* header */}
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <h5 className="  modal-title" id="ModalLabel">
                Finish Task
              </h5>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>

          <div className="modal-body">
            {/* <div className="d-flex">Finish</div> */}

            <div className="row"></div>
            {/* work from */}
            <div className="col-md-6">
              <label className="form-label">Work From</label>
              <DatePicker
                closeOnScroll={true}
                selected={save_data.work_from}
                onChange={(date) => {
                  console.log("work_from :", date);
                  //   let value = moment(date).format("DD-MM-yyyy h:mm a");
                  SetSaveData((prevValue: any) => {
                    prevValue.work_from = date;
                    return { ...prevValue };
                  });
                }}
                className="form-control"
                placeholderText="From Date"
                showTimeSelect
                timeFormat="HH:mm"
                dateFormat="MMMM d, yyyy h:mm aa"
              />
            </div>
            {/* work to */}
            <div className="col-md-6">
              <label className="form-label">Work To</label>
              <DatePicker
                closeOnScroll={true}
                selected={save_data.work_to}
                onChange={(date) => {
                  console.log("work_to :", date);
                  //   let value = moment(date).format("DD-MM-yyyy h:mm a");
                  SetSaveData((prevValue: any) => {
                    prevValue.work_to = date;
                    return { ...prevValue };
                  });
                }}
                className="form-control"
                placeholderText="To Date"
                showTimeSelect
                timeFormat="HH:mm"
                dateFormat="MMMM d, yyyy h:mm aa"
                // maxDate={to_date}
              />
            </div>
            {/* File path */}
            <div className="col-md-6">
              <label className="form-label">File Path</label>
              <input
                type="text"
                className="form-control"
                value={save_data.file_path}
                onChange={(e) => {
                  SetSaveData((prevValue: any) => {
                    prevValue.file_path = e.target.value;
                    return { ...prevValue };
                  });
                }}
              />
            </div>
            {/* reason */}
            <div className="col-md-6">
              <label className="form-label">Reason</label>
              <textarea
                type="text"
                className="form-control"
                value={save_data.reason}
                onChange={(e) => {
                  SetSaveData((prevValue: any) => {
                    prevValue.reason = e.target.value;
                    return { ...prevValue };
                  });
                }}
              />
            </div>
            {/* quantity */}
            <div className="col-md-6">
              <label className="form-label">Quantity</label>
              <input
                type="number"
                className="form-control"
                value={save_data.quantity}
                onChange={(e) => {
                  SetSaveData((prevValue: any) => {
                    prevValue.quantity = e.target.value;
                    return { ...prevValue };
                  });
                }}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                console.log("Finish");
                finish_task();
              }}
            >
              Finish
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
